export const CONFIRMATION_OPTIONS = [
	{ label: 'Shipping', value: 'shipping' },
	{ label: 'Online Payment', value: 'online_payment' },
];
